import { Button, Form, Input, message } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { IProvinceChange } from 'src/components/common/ProvinceSelect';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo, ISubDrugStore } from 'src/entity/DrugStoreEntity';
import { ILocationInfo } from 'src/entity/LocationEntity';
import { reloadDrugStores } from 'src/redux/actions/drugStoreCreator';
import { fetchLocationsIfNeeded } from 'src/redux/actions/locationCreator';
import DrugStoreService from 'src/services/DrugStoreService';
import I18N from 'src/services/I18NService';
import UserService, { ROLE_DRUGSTORE } from 'src/services/UserService';
import { IStateCollection } from 'src/entity/StateEntity';

interface IDrugStoreAddFormProps extends FormComponentProps, RouteComponentProps {
  isAgent: boolean;
  isDomestic: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  locations: ILocationInfo[];
  dispatch: Dispatch<IStateCollection>;
}

class DrugStoreAddForm extends React.Component<IDrugStoreAddFormProps, any> {
  canSubmit = true;
  reloadDrugStore = false;
  locationAddress: string = '';

  constructor(props: IDrugStoreAddFormProps) {
    super(props);
  }

  async componentDidMount() {
    await this.props.dispatch(fetchLocationsIfNeeded());
  }

  componentWillUnmount() {
    if (this.reloadDrugStore) {
      this.props.dispatch(reloadDrugStores());
    }
  }

  goback = () => {
    this.props.history.goBack();
  };

  provinceChange = (value: IProvinceChange) => {
    this.locationAddress = value.desc;
    this.props.form.setFieldsValue({
      location: value.location,
    });
  };

  locationChange = (value: number) => {
    const obj = this.props.locations.find(t => t.id === value);
    this.locationAddress = !!obj ? obj.name : '';
  };

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (!this.canSubmit) {
          return;
        }
        try {
          const data: ISubDrugStore = {
            location: values.location,
            address: `${this.locationAddress} ${values.address}`,
            admin_mobile: values.admin_mobile,
            admin_email: values.admin_email,
            is_active: values.is_active,
            name: values.name,
            admin_password: values.admin_password,
            admin_name: values.admin_name,
            admin_username: values.admin_username,
          };
          this.canSubmit = false;
          const result = await DrugStoreService.createDrugStore(data);
          if (!!result && !!result.admin_uuid) {
            await UserService.createUserRole(result.admin_uuid, ROLE_DRUGSTORE);
            this.reloadDrugStore = true;
            message.success(I18N.get('common_save_success'));
            this.props.form.resetFields();
          }
          this.canSubmit = true;
        } catch (error) {
          this.canSubmit = true;
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        }
      }
    });
  };

  render() {
    const { isAgent, userInfo, isDomestic } = this.props;
    // let userInfo: IDrugStoreInfo | undefined;
    // if (!isAgent) {
    //   userInfo = userInfo as IDrugStoreInfo;
    // }
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 6 },
    };
    return (
      <div>
        {/* {isAgent && ( */}
          {/* <div style={{ marginBottom: '24px', textAlign: 'right' }}> */}
            {/* <Button type="primary" onClick={this.goback}> */}
              {/* {I18N.get('common_back')} */}
            {/* </Button> */}
          {/* </div> */}
        {/* )} */}
        <Form onSubmit={this.handleSubmit}>
          <Form.Item label={I18N.get('common_name_desc')} {...formItemLayout}>
            {getFieldDecorator(`name`, {
              rules: [
                {
                  required: false,
                  // message: `{${I18N.get('common_input')}${I18N.get('drug_store_name')}}`,
                },
              ],
              initialValue: !!userInfo ? userInfo.name : undefined,
            })(<Input disabled={true} />)}
          </Form.Item>
          {/* {isAgent && isDomestic && (
            <Form.Item label={I18N.get('common_area')} {...formItemLayout}>
              {getFieldDecorator(`location`, {
                rules: [
                  {
                    required: false,
                    message: `{${I18N.get('common_input')}${I18N.get('common_area')}}`,
                  },
                ],
              })(<ProvinceSelect provinceChange={this.provinceChange} disabled={false} />)}
            </Form.Item>
          )} */}
          {/* {isAgent && !isDomestic && (
            <Form.Item label={I18N.get('common_area')} {...formItemLayout}>
              {getFieldDecorator(`location`, {
                rules: [
                  {
                    required: false,
                    message: `{${I18N.get('common_input')}${I18N.get('common_area')}}`,
                  },
                ],
              })(
                <Select onChange={this.locationChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_price_area')}`}>
                  {locations.map(p => {
                    return (
                      <Select.Option key={String(p.id)} value={p.id}>
                        {p.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
          )} */}
          <Form.Item label={I18N.get('common_full_address')} {...formItemLayout}>
            {getFieldDecorator(`address`, {
              rules: [
                {
                  required: false,
                  // message: `{${I18N.get('common_input')}${I18N.get('common_full_address')}}`,
                },
              ],
              initialValue: !!userInfo ? userInfo.address : undefined,
            })(<Input disabled={true} />)}
          </Form.Item>
          <Form.Item label={I18N.get('common_admin')} {...formItemLayout}>
            {getFieldDecorator(`admin_name`, {
              rules: [
                {
                  required: false,
                  // message: `{${I18N.get('common_input')}${I18N.get('common_admin')}}`,
                },
              ],
              initialValue: !!userInfo ? userInfo.admin_name : undefined,
            })(<Input disabled={true} />)}
          </Form.Item>
          <Form.Item label={I18N.get('login_userName')} {...formItemLayout}>
            {getFieldDecorator(`admin_username`, {
              rules: [
                {
                  required: false,
                  // message: `{${I18N.get('common_input')}${I18N.get('login_userName')}}`,
                },
              ],
              initialValue: !!userInfo ? userInfo.admin_username : undefined,
            })(<Input disabled={true} />)}
          </Form.Item>
          {isDomestic && (
            <Form.Item label={I18N.get('common_mobile')} {...formItemLayout}>
              {getFieldDecorator(`admin_mobile`, {
                rules: [
                  {
                    required: false,
                    // message: `{${I18N.get('common_input')}${I18N.get('common_mobile')}}`,
                  },
                ],
                initialValue: !!userInfo ? userInfo.admin_mobile : undefined,
              })(<Input disabled={true} />)}
            </Form.Item>
          )}
          {isDomestic && (
            <Form.Item label="email" {...formItemLayout}>
              {getFieldDecorator(`admin_email`, {
                rules: [
                  {
                    required: false,
                    // message: `{${I18N.get('common_input')} email}`,
                  },
                ],
                initialValue: !!userInfo ? userInfo.admin_email : undefined,
              })(<Input type="email" disabled={true} />)}
            </Form.Item>
          )}
          {!isDomestic && (
            <Form.Item label="email" {...formItemLayout}>
              {getFieldDecorator(`admin_email`, {
                rules: [
                  {
                    required: false,
                    // message: `{${I18N.get('common_input')} email}`,
                  },
                ],
                initialValue: !!userInfo ? userInfo.admin_email : undefined,
              })(<Input type="email" disabled={true} />)}
            </Form.Item>
          )}
          {!isDomestic && (
            <Form.Item label={I18N.get('common_mobile')} {...formItemLayout}>
              {getFieldDecorator(`admin_mobile`, {
                rules: [
                  {
                    required: false,
                    // message: `{${I18N.get('common_input')}${I18N.get('common_mobile')}}`,
                  },
                ],
                initialValue: !!userInfo ? userInfo.admin_mobile : undefined,
              })(<Input disabled={true} />)}
            </Form.Item>
          )}
          {/* {isAgent && (
            <Form.Item label={I18N.get('login_pwd')} {...formItemLayout}>
              {getFieldDecorator(`admin_password`, {
                rules: [
                  {
                    required: false,
                    message: `{${I18N.get('common_input')}${I18N.get('login_pwd')}}`,
                  },
                ],
              })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('login_pwd')}`} />)}
            </Form.Item>
          )} */}
          {/* {isAgent && (
            <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
              <Button type="primary" htmlType="submit">
                {I18N.get('common_save')}
              </Button>
            </Form.Item>
          )} */}
        </Form>
      </div>
    );
  }
}

const DrugStoreAddComponent = Form.create<IDrugStoreAddFormProps>()(DrugStoreAddForm);
export default DrugStoreAddComponent;



// WEBPACK FOOTER //
// ./src/components/views/DrugStore/DrugStoreAddPage.tsx